import { useEffect } from 'react';
import { attachGlobalButtonTracking, getMetrikaCounterId, initMetrika, trackPageView } from './metrika';

export const useMetrikaTracking = (location) => {
  const currentPath = location ? `${location.pathname}${location.search}${location.hash}` : null;

  useEffect(() => {
    const counterId = getMetrikaCounterId();
    if (!counterId) {
      return undefined;
    }

    initMetrika(counterId);
    const detachButtonTracking = attachGlobalButtonTracking();

    return () => {
      if (typeof detachButtonTracking === 'function') {
        detachButtonTracking();
      }
    };
  }, []);

  useEffect(() => {
    if (!currentPath) {
      return;
    }

    trackPageView(currentPath);
  }, [currentPath]);
};

export default useMetrikaTracking;
